export default __webpack_public_path__ + "static/media/userIcon-register.81ec1098.svg";